export default {
  ID_CYSTACK_URL: process.env.REACT_APP_CYSTACK_ID_URL,
  IMAGE_LOGO_SERVER_URL: "https://web.cystack.net/logo/:address",
  SLACK_OAUTH: "https://slack.com/oauth/authorize",
  GOOGLE_TAG_ID_SUPPORT_URL: "https://support.google.com/analytics/answer/9539598?hl=en"
};
